export default __webpack_public_path__ + "static/media/rotating-card-bg-front.1f7e9988.jpeg";